import { useLocation } from 'react-router-dom'
import { ModuleVOConfigScope } from '../moduleVoNavigation'

export interface ModuleVOConfigParams {
    scope: ModuleVOConfigScope
}

export function useModuleVOConfigParams(): ModuleVOConfigParams {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const scopeParam = searchParams.get('scope')
    const scope: ModuleVOConfigScope = scopeParam === 'brand' || scopeParam === 'site' ? scopeParam : 'global'

    return { scope }
}
